import React, {Component, useEffect, useState,} from 'react';
import ContentSettingForm from '../../components/contents/setting/ContentSettingForm'
import { jsonResponseHandler } from '../../utils/FetchHelper'
import LoadingBox from "../../components/common/LoadingBox";
import {connect, useDispatch} from "react-redux";
import LoadErrorBox from "../../components/common/LoadErrorBox";
import * as InitStatus from '../../constants/common/InitializationStatus';
import {addPrefix} from "../../utils/UriUtil";


export default function ContentSettingApp() {
  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)
  const [data, setData] = useState(null)

  useEffect(() => {
    setInitialized(InitStatus.INIT_DOING)
    fetch(addPrefix("/manage/setting/contents.json"), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        setData(data)
        setInitialized(InitStatus.INIT_SUCCESS)
      })
      .catch(e => {
        console.error(e);
        setInitialized(InitStatus.INIT_FAIL)
      })
  }, [])

  return (
    <div className="inner_article">
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
      { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
      { (initialized === InitStatus.INIT_SUCCESS ) && <h3 className="tit_cont">콘텐츠 설정</h3> }
      { (initialized === InitStatus.INIT_SUCCESS ) && <ContentSettingForm data={data} /> }
    </div>
  )
}
